import { createBrowserRouter } from 'react-router-dom';
import { appRoutes } from 'router/appRoutes';

export const Router = createBrowserRouter(appRoutes);
